import axios, { AxiosResponse } from 'axios'; //npm install axios --save //npm install --save es6-promise For IE
import { Constant } from '@/helpers/constant';
import { Rest, RestHeader } from '@/helpers/rest';
import router from '@/router';

class UpSkillService {
  axios;
  constructor() {
    this.axios = axios.create({});
  }

  public getConditionalQuestions(): Promise<AxiosResponse<any>> {
    let data ={
      provider:Constant.JOBSEEKER_PROVIDER
    };
    return this.axios.post(Constant.SERVER_URL+"api/getConditionalQuestionsFRomupskill",data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITHOUT_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
           alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }
  public getCoursesById(data): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL+"api/getCoursesById",data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITHOUT_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
           alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }

  public applyCourseForJobseeker(data): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL+"api/applyCourseForJobseeker",data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITHOUT_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
           alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }
  public searchCoursesForDashboard(data): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL_WITH_API+"v1/courses_list_by_category",data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITHOUT_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
           alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          alert("Gateway Time out");
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }

  public getTotalCoursesCountForHomePage(data): Promise<AxiosResponse<any>> {
    return this.axios
      .post(
        Constant.SERVER_URL_WITH_API + "v1/homeStatistic",
        data,
        {
          headers: Rest.getHeaders(
            RestHeader.APPLICATION_JSON_WITHOUT_BEARER_TOKEN
          ),
        }
      )
      .then((ag) => {
        return ag;
      })
      .catch((err) => {
        if (err == "Error: Request failed with status code 401") {
          alert("Upskill Malaysia Unauthorized");
          localStorage.clear();
          router.push("/");
        } else if (err == "Error: Request failed with status code 500") {
          return err;
        } else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }


 public getTotalEnrolmentsCountForCollabPage(data): Promise<AxiosResponse<any>> {
    return this.axios
      .post(
        Constant.SERVER_URL_WITH_API + "v1/collabStatistic",
        data,
        {
          headers: Rest.getHeaders(
            RestHeader.APPLICATION_JSON_WITHOUT_BEARER_TOKEN
          ),
        }
      )
      .then((ag) => {
        return ag;
      })
      .catch((err) => {
        if (err == "Error: Request failed with status code 401") {
          alert("Upskill Malaysia Unauthorized");
          localStorage.clear();
          router.push("/");
        } else if (err == "Error: Request failed with status code 500") {
          return err;
        } else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }


  public getAllSkills(data): Promise<AxiosResponse<any>> {
    return this.axios
      .post(
        Constant.SERVER_URL_WITH_API + "admin/KeySkillList",
        data,
        {
          headers: Rest.getHeaders(
            RestHeader.APPLICATION_JSON_WITHOUT_BEARER_TOKEN
          ),
        }
      )
      .then((ag) => {
        return ag;
      })
      .catch((err) => {
        if (err == "Error: Request failed with status code 401") {
          alert("Upskill Malaysia Unauthorized");
          localStorage.clear();
          router.push("/");
        } else if (err == "Error: Request failed with status code 500") {
          return err;
        } else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }
  public sendContactDetails(data): Promise<AxiosResponse<any>> {
    return this.axios
      .post(
        Constant.SERVER_URL_WITH_API + "jobseeker/contactUs",
        data,
        {
          headers: Rest.getHeaders(
            RestHeader.APPLICATION_JSON_WITHOUT_BEARER_TOKEN
          ),
        }
      )
      .then((ag) => {
        return ag;
      })
      .catch((err) => {
        if (err == "Error: Request failed with status code 401") {
          alert("Upskill Malaysia Unauthorized");
          localStorage.clear();
          router.push("/");
        } else if (err == "Error: Request failed with status code 500") {
          return err;
        } else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }
  public gethomeCourseCount(data): Promise<AxiosResponse<any>> {
    return this.axios
      .post(
        Constant.SERVER_URL_WITH_API + "v1/homeCourseCount",
        data,
        {
          headers: Rest.getHeaders(
            RestHeader.APPLICATION_JSON_WITHOUT_BEARER_TOKEN
          ),
        }
      )
      .then((ag) => {
        return ag;
      })
      .catch((err) => {
        if (err == "Error: Request failed with status code 401") {
          alert("Upskill Malaysia Unauthorized");
          localStorage.clear();
          router.push("/");
        } else if (err == "Error: Request failed with status code 500") {
          return err;
        } else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }
  public getTrendingCourseCount(data): Promise<AxiosResponse<any>> {
    return this.axios
      .post(
        Constant.SERVER_URL_WITH_API + "v1/trendingCourse",
        data,
        {
          headers: Rest.getHeaders(
            RestHeader.APPLICATION_JSON_WITHOUT_BEARER_TOKEN
          ),
        }
      )
      .then((ag) => {
        return ag;
      })
      .catch((err) => {
        if (err == "Error: Request failed with status code 401") {
          alert("Upskill Malaysia Unauthorized");
          localStorage.clear();
          router.push("/");
        } else if (err == "Error: Request failed with status code 500") {
          return err;
        } else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }
  public getLearnCert(data): Promise<AxiosResponse<any>> {
    return this.axios
      .post(
        Constant.SERVER_URL_WITH_API + "v1/eLearnCert",
        data,
        {
          headers: Rest.getHeaders(
            RestHeader.APPLICATION_JSON_WITHOUT_BEARER_TOKEN
          ),
        }
      )
      .then((ag) => {
        return ag;
      })
      .catch((err) => {
        if (err == "Error: Request failed with status code 401") {
          alert("Upskill Malaysia Unauthorized");
          localStorage.clear();
          router.push("/");
        } else if (err == "Error: Request failed with status code 500") {
          return err;
        } else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }
  // public getSPCert(data): Promise<AxiosResponse<any>> {
  //   return this.axios
  //     .post(
  //       Constant.SWV1_URL + "v1/spSearch",
  //       data,
  //       {
  //         headers: Rest.getHeaders(
  //           RestHeader.APPLICATION_JSON_WITHOUT_BEARER_TOKEN
  //         ),
  //       }
  //     )
  //     .then((ag) => {
  //       return ag;
  //     })
  //     .catch((err) => {
  //       if (err == "Error: Request failed with status code 401") {
  //         alert("Upskill Malaysia Unauthorized");
  //         localStorage.clear();
  //         router.push("/");
  //       } else if (err == "Error: Request failed with status code 500") {
  //         return err;
  //       } else if (err == "Error: Request failed with status code 400") {
  //         alert("Bad Request!");
  //         return err;
  //       } else if (err == "Error: Request failed with status code 404") {
  //         alert("Page Not Found!");
  //         localStorage.clear();
  //         router.push('/');
  //       }
  //       return err;
  //       // Manage the state of the application if the request
  //       // has failed
  //     });
  // }
  public getSPCert(data): Promise<AxiosResponse<any>> {
    return this.axios
      .post(
        Constant.SERVER_URL_WITH_API + "v1/spCert",
        data,
        {
          headers: Rest.getHeaders(
            RestHeader.APPLICATION_JSON_WITHOUT_BEARER_TOKEN
          ),
        }
      )
      .then((ag) => {
        return ag;
      })
      .catch((err) => {
        if (err == "Error: Request failed with status code 401") {
          alert("Upskill Malaysia Unauthorized");
          localStorage.clear();
          router.push("/");
        } else if (err == "Error: Request failed with status code 500") {
          return err;
        } else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }
  public getCourseDetails(data): Promise<AxiosResponse<any>> {
    return this.axios
      .post(
        Constant.SERVER_URL_WITH_API + "v1/homeCourseShow",
        data,
        {
          headers: Rest.getHeaders(
            RestHeader.APPLICATION_JSON_WITHOUT_BEARER_TOKEN
          ),
        }
      )
      .then((ag) => {
        return ag;
      })
      .catch((err) => {
        if (err == "Error: Request failed with status code 401") {
          alert("Upskill Malaysia Unauthorized");
          localStorage.clear();
          router.push("/");
        } else if (err == "Error: Request failed with status code 500") {
          return err;
        } else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }
  public getCourseHistoryForTrainee(data): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL+"api/getCourseHistoryForTrainee",data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITHOUT_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
           alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          alert("Gateway Time out");
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }
  public withdrawCourse(data): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL+"api/withdrawCourse",data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
           alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          alert("Gateway Time out");
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }
  public updateCourseRating(data): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL+"api/applicantCourseRating",data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITHOUT_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
           alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          alert("Gateway Time out");
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }
  public getCourseStatisticsForTrainee(data): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL+"api/getCourseStatisticsForDashboard",data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITHOUT_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
           alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          alert("Gateway Time out");
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }
  public getQuestionsByCourse(data): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL+"api/getQuestionsByCourseForEmployer",data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITHOUT_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
           alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          alert("Gateway Time out");
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }
    public getQuestionsForCourse(data): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL+"api/getQuestionsForCourse",data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITHOUT_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
           alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          alert("Gateway Time out");
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }
  public bulkApplyCourseForEmployee(data): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL+"api/bulkApplyCourseForEmployee",data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITHOUT_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
           alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          alert("Gateway Time out");
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }

  public getTopCoursesCatagory(data): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL_WITH_API + "v1/courses_by_category",data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          alert("Gateway Time out");
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }

  public getAllPillars(data): Promise<AxiosResponse<any>> {
    return this.axios
      .post(
        Constant.SERVER_URL_WITH_API + "admin/Pillars",
        data,
        {
          headers: Rest.getHeaders(
            RestHeader.APPLICATION_JSON_WITHOUT_BEARER_TOKEN
          ),
        }
      )
      .then((ag) => {
        return ag;
      })
      .catch((err) => {
        if (err == "Error: Request failed with status code 401") {
          alert("Upskill Malaysia Unauthorized");
          localStorage.clear();
          router.push("/");
        } else if (err == "Error: Request failed with status code 500") {
          return err;
        } else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }

  public getCpList(data): Promise<AxiosResponse<any>> {
    return this.axios
      .post(
        Constant.SERVER_URL_WITH_API + "v1/coursecplist",
        data,
        {
          headers: Rest.getHeaders(
            RestHeader.APPLICATION_JSON_WITHOUT_BEARER_TOKEN
          ),
        }
      )
      .then((ag) => {
        return ag;
      })
      .catch((err) => {
        if (err == "Error: Request failed with status code 401") {
          alert("Upskill Malaysia Unauthorized");
          localStorage.clear();
          router.push("/");
        } else if (err == "Error: Request failed with status code 500") {
          return err;
        } else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }

  public gethomeCourseCountArchived(data): Promise<AxiosResponse<any>> {
    return this.axios
      .post(
        Constant.SERVER_URL_WITH_API + "v1/homeCourseCountArchive",
        data,
        {
          headers: Rest.getHeaders(
            RestHeader.APPLICATION_JSON_WITHOUT_BEARER_TOKEN
          ),
        }
      )
      .then((ag) => {
        return ag;
      })
      .catch((err) => {
        if (err == "Error: Request failed with status code 401") {
          alert("Upskill Malaysia Unauthorized");
          localStorage.clear();
          router.push("/");
        } else if (err == "Error: Request failed with status code 500") {
          return err;
        } else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }

  public getAllSkillsAlt(data): Promise<AxiosResponse<any>> {
    return this.axios
      .post(
        Constant.SERVER_URL_WITH_API + "v1/coursekeyskilllist",
        data,
        {
          headers: Rest.getHeaders(
            RestHeader.APPLICATION_JSON_WITHOUT_BEARER_TOKEN
          ),
        }
      )
      .then((ag) => {
        return ag;
      })
      .catch((err) => {
        if (err == "Error: Request failed with status code 401") {
          alert("Upskill Malaysia Unauthorized");
          localStorage.clear();
          router.push("/");
        } else if (err == "Error: Request failed with status code 500") {
          return err;
        } else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }

  public getSatelliteEventsRegion(data): Promise<AxiosResponse<any>> {
    return this.axios
      .post(
        Constant.SERVER_URL_WITH_API + "v1/satelliteEventsRegion",
        data,
        {
          headers: Rest.getHeaders(
            RestHeader.APPLICATION_JSON_WITHOUT_BEARER_TOKEN
          ),
        }
      )
      .then((ag) => {
        return ag;
      })
      .catch((err) => {
        if (err == "Error: Request failed with status code 401") {
          alert("Upskill Malaysia Unauthorized");
          localStorage.clear();
          router.push("/");
        } else if (err == "Error: Request failed with status code 500") {
          return err;
        } else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }
  public getSatelliteEvents(data): Promise<AxiosResponse<any>> {
    return this.axios
      .post(
        Constant.SERVER_URL_WITH_API + "v1/satelliteEventsList",
        data,
        {
          headers: Rest.getHeaders(
            RestHeader.APPLICATION_JSON_WITHOUT_BEARER_TOKEN
          ),
        }
      )
      .then((ag) => {
        return ag;
      })
      .catch((err) => {
        if (err == "Error: Request failed with status code 401") {
          alert("Upskill Malaysia Unauthorized");
          localStorage.clear();
          router.push("/");
        } else if (err == "Error: Request failed with status code 500") {
          return err;
        } else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }


  public getApplicantCourseInfo(data): Promise<AxiosResponse<any>> {
    return this.axios
      .post(
        Constant.SERVER_URL_WITH_API + "v1/getApplicantCourseInfo",
        data,
        {
          headers: Rest.getHeaders(
            RestHeader.APPLICATION_JSON_WITHOUT_BEARER_TOKEN
          ),
        }
      )
      .then((ag) => {
        return ag;
      })
      .catch((err) => {
        if (err == "Error: Request failed with status code 401") {
          alert("Upskill Malaysia Unauthorized");
          localStorage.clear();
          router.push("/");
        } else if (err == "Error: Request failed with status code 500") {
          return err;
        } else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }


  public getElearningTrendingCourse(data): Promise<AxiosResponse<any>> {
    return this.axios
      .post(
        Constant.SERVER_URL_WITH_API + "v1/trendingCourse",
        data,
        {
          headers: Rest.getHeaders(
            RestHeader.APPLICATION_JSON_WITHOUT_BEARER_TOKEN
          ),
        }
      )
      .then((ag) => {
        return ag;
      })
      .catch((err) => {
        if (err == "Error: Request failed with status code 401") {
          alert("Upskill Malaysia Unauthorized");
          localStorage.clear();
          router.push("/");
        } else if (err == "Error: Request failed with status code 500") {
          return err;
        } else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }

  public getPageVisitCount(data): Promise<AxiosResponse<any>> {
    return this.axios
      .post(
        Constant.SERVER_URL_WITH_API + "getVisitPage",
        data,
        {
          headers: Rest.getHeaders(
            RestHeader.APPLICATION_JSON_WITHOUT_BEARER_TOKEN
          ),
        }
      )
      .then((ag) => {
        return ag;
      })
      .catch((err) => {
        if (err == "Error: Request failed with status code 401") {
          alert("Upskill Malaysia Unauthorized");
          localStorage.clear();
          router.push("/");
        } else if (err == "Error: Request failed with status code 500") {
          return err;
        } else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }

  public getBanner(data): Promise<AxiosResponse<any>> {
    return this.axios
      .post(
        Constant.SERVER_URL_WITH_API + "getBanner",
        data,
        {
          headers: Rest.getHeaders(
            RestHeader.APPLICATION_JSON_WITHOUT_BEARER_TOKEN
          ),
        }
      )
      .then((ag) => {
        return ag;
      })
      .catch((err) => {
        if (err == "Error: Request failed with status code 401") {
          alert("Upskill Malaysia Unauthorized");
          localStorage.clear();
          router.push("/");
        } else if (err == "Error: Request failed with status code 500") {
          return err;
        } else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }

  public getPartners(data): Promise<AxiosResponse<any>> {
    return this.axios
      .post(
        Constant.SERVER_URL_WITH_API + "getPartners",
        data,
        {
          headers: Rest.getHeaders(
            RestHeader.APPLICATION_JSON_WITHOUT_BEARER_TOKEN
          ),
        }
      )
      .then((ag) => {
        return ag;
      })
      .catch((err) => {
        if (err == "Error: Request failed with status code 401") {
          alert("Upskill Malaysia Unauthorized");
          localStorage.clear();
          router.push("/");
        } else if (err == "Error: Request failed with status code 500") {
          return err;
        } else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }

  public getCountry(data): Promise<AxiosResponse<any>> {
    return this.axios
      .post(
        Constant.SERVER_URL_WITH_API + "getCountry",
        data,
        {
          headers: Rest.getHeaders(
            RestHeader.APPLICATION_JSON_WITHOUT_BEARER_TOKEN
          ),
        }
      )
      .then((ag) => {
        return ag;
      })
      .catch((err) => {
        if (err == "Error: Request failed with status code 401") {
          alert("Upskill Malaysia Unauthorized");
          localStorage.clear();
          router.push("/");
        } else if (err == "Error: Request failed with status code 500") {
          return err;
        } else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }

  public getImages(data): Promise<AxiosResponse<any>> {
    return this.axios
      .post(
        Constant.SERVER_URL_WITH_API + "getImages",
        data,
        {
          headers: Rest.getHeaders(
            RestHeader.APPLICATION_JSON_WITHOUT_BEARER_TOKEN
          ),
        }
      )
      .then((ag) => {
        return ag;
      })
      .catch((err) => {
        if (err == "Error: Request failed with status code 401") {
          alert("Upskill Malaysia Unauthorized");
          localStorage.clear();
          router.push("/");
        } else if (err == "Error: Request failed with status code 500") {
          return err;
        } else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }
}
export default new UpSkillService();